import { ColDef } from '@ag-grid-community/core';
import { ForgeIcon } from '@tylertech/forge-react';
import { OrderConfig, SortDirection } from 'common/visualizations/vif';
import React from 'react';
import ReactDOM from 'react-dom';
import { getCurrentSort } from './SortHelpers';

export const renderIcon = (
  name: string,
  classNames: string = 'ag-sort-indicator-icon ag-custom-header-icon'
) => {
  const container = document.createElement('span');
  container.className = classNames;
  ReactDOM.render(<ForgeIcon external external-type="standard" name={name} />, container);
  return container;
};

export interface GetSortIconsProps {
  columnName: string;
}

export const createGetSortIcons = (orderConfig: OrderConfig[]) => {
  return (props: GetSortIconsProps): Partial<ColDef['icons']> => {
    const { columnName } = props;
    const currentSort: SortDirection = getCurrentSort({ orderConfig, columnName });
    const iconMap: Record<string, string> = {
      descending: 'arrow_downward',
      ascending: 'arrow_upward'
    };
    return {
      sortAscending: () => {
        return renderIcon(iconMap[currentSort as string] || 'swap_vert');
      },
      sortDescending: () => {
        return renderIcon(iconMap[currentSort as string] || 'swap_vert');
      }
    };
  };
};

interface SortIconReturnType {
  [key: string]: string | ((...args: any[]) => any);
}

export interface ISortIcons {
  (props: GetSortIconsProps): Partial<SortIconReturnType> | undefined;
}
